module.exports = __webpack_public_path__ + "img/addxnwl1.c0f04494.png";